import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalStateService } from '../../core/services/global-state.service';

@Injectable({ providedIn: 'root' })
export class DashboardCheckService {
    public constructor(private router: Router, private globalStateService: GlobalStateService) {}

    public isInDashboardWithUserId(): boolean {
        const url: string = this.router.url;
        const hasDashboard: boolean = url.includes('dashboard');

        return hasDashboard && !!this.globalStateService.userId;
    }
}
